import handlebars from "handlebars";
import { GetAppraisalModel } from "../../../../../all_Interfaces";
import currencySymbolMap from "currency-symbol-map";
import equityAppraisalValuesTemplates from "../templates/equityAppraisalValuesTemplates";
import { isReturnStatement } from "typescript";

export const compileEquityAppraisalValuesTemplate = (
    appraisalData:GetAppraisalModel
  ): string => {
    const compiledEquityAppraisalValuesTemplate = handlebars.compile(equityAppraisalValuesTemplates);
    const dayjs = require('dayjs');


    var currencySymbol = "$";
    if(appraisalData.currency != "ZH"){
        currencySymbol = currencySymbolMap(appraisalData.currency) as string
    }else{
        currencySymbol = "ZH";
    }if(appraisalData.currency == ""){
      currencySymbol = "$";
    }

    var currentDate = new Date(appraisalData.valueDate);
    var lastDate = new Date(appraisalData.lastAppraisalDate);
    var annualDate = new Date(appraisalData.lastAnnualAppraisalDate);
    const currentDateString:string = currentDate.toLocaleString();
    const lastDateString:string = lastDate.toLocaleString();
    const annualDateString:string = annualDate.toLocaleString();
    
    const formatNumber = (params:any) => {
        if(params !== null)
          return params.toLocaleString('en-US');
         
      }
      const formatNumberTo0Decimal = (num: any) => {
        const regxmain = /^-?\d+(\.\d+)?$/;
        const regex1 = /^\d+\.\d{1}$/;
        const regx2 = /^\d+$/;
        const regx3 = /^-?\d+\.\d{1}$/; // tocheck - number
        if (regxmain.test(num)) {
          return num.toFixed(2);
        }
        // if (regex1.test(num)) {
        //   return num.toFixed(2);
        // }else  if(regx2.test(num)) {
        //   return num.toFixed(2);
        // }else if(regx3.test(num)){
        //   return `${num.toFixed(2)}`;
        // }
        return num;
      }

    const appraisalValues = {
       currentAppraisalValue:formatNumber(appraisalData.currentAppraisalValue),
       currency:appraisalData.currency,
       currencySymbol: currencySymbol,
       currentPercentageChange : formatNumberTo0Decimal(appraisalData.percentageChange),
       annualPercentageChange : formatNumberTo0Decimal(appraisalData.annualPercentageChange),
       lastAppraisedValue : formatNumber(appraisalData.lastAppraisedValue),
       annualAppraisedValue : formatNumber(appraisalData.lastAnnualAppraisedValue),
       scheduleNValue:formatNumber(appraisalData.scheduleNCost),
       currentDate:dayjs(currentDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss"),
       lastDate:dayjs(lastDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss"),
       annualDate:dayjs(annualDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss")
    }

    return compiledEquityAppraisalValuesTemplate(appraisalValues);
}